import { render, staticRenderFns } from "./CoozzyNavigationItem.vue?vue&type=template&id=d4a84032&scoped=true"
import script from "./CoozzyNavigationItem.vue?vue&type=script&lang=js"
export * from "./CoozzyNavigationItem.vue?vue&type=script&lang=js"
import style0 from "./CoozzyNavigationItem.vue?vue&type=style&index=0&id=d4a84032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a84032",
  null
  
)

export default component.exports